import React, { useState, useRef, useEffect } from 'react';

type FilterDropdownProps = {
  options: any;
  onChange: (value: string) => void;
  placeholder?: string;
};

const FilterDropdown: React.FC<FilterDropdownProps> = ({ options, onChange, placeholder = 'Filter' }) => {
  console.log(options)
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<string | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (value: any) => {
    setSelected(value.name);
    setIsOpen(false);
    onChange(value);
  };

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <div>
        <button
          type="button"
          className="inline-flex w-full justify-between rounded-md bg-white ring-1 ring-slate-300 px-4 py-[7px] text-sm font-medium text-gray-700 shadow-sm  hover:bg-gray-50"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {selected || placeholder}
          <svg
            className="-mr-1 ml-2 h-5 w-5 text-gray-400"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.72-3.71a.75.75 0 111.06 1.06l-4.25 4.25a.75.75 0 01-1.06 0l-4.25-4.25a.75.75 0 01.02-1.06z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>

      {isOpen && (
        <div className="absolute z-10 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5">
          <div className="py-1 text-sm text-gray-700">
            {options.map((option : any) => (
              <button
                key={option}
                onClick={() => handleSelect(option)}
                className={`block w-full text-left px-4 py-2 hover:bg-gray-100 ${
                  selected === option ? 'bg-gray-100 font-medium' : ''
                }`}
              >
                {option.name}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;
